// import notificationIcon from '@/assets/img/nav/ic-notification.svg';
// import marketplaceIcon from '@/assets/img/nav/ic-marketplace.svg';
// import jobsIcon from '@/assets/img/nav/ic-jobs.svg';
import logoutIcon from '@/assets/img/nav/ic-logout.svg';
import settingsIcon from '@/assets/img/nav/ic-settings.svg';

const AUTH_ROUTES = [
  // Module: Post Feed (Jobs)
  // Uncomment the links here for Post Feed
  // {
  //   title: 'Browse Jobs',
  //   link: { name: 'job-feed' },
  //   icon: '',
  //   class: 'font-weight-bold',
  // },
  // { title: 'Create a Job', link: { name: 'job-feed-create' } },
  // { title: 'Saved Jobs', link: { name: 'job-feed-saved' } },
  // { title: 'My Jobs', link: { name: 'job-feed-my-jobs' } },

  // Module: Post Feed
  // Uncomment the links here for Post Feed
  // {
  //   title: 'Newsfeed',
  //   link: { name: 'newsfeed' },
  //   icon: '',
  //   class: 'font-weight-bold',
  // },
  // { title: 'My Posts', link: { name: 'my-posts' } },

  // Module: Marketplace
  // Uncomment the links here for Marketplace
  // {
  //   title: 'Market Place',
  //   link: { name: 'marketplace' },
  //   icon: marketplaceIcon,
  //   class: 'font-weight-bold',
  // },
  // { title: 'List an Item', link: { name: 'marketplace-new' } },
  // { title: 'Your Listings', link: { name: 'marketplace' } },

  // Module: Chat
  // Uncomment the links here for Chat
  // {
  //   title: 'Messages',
  //   icon: 'mdi-send',
  //   mdi: true,
  //   class: 'font-weight-bold',
  //   link: { name: 'messages' },
  // },

  // Module: Notification
  // Uncomment the links here for Notification
  // {
  //   title: 'Notifications',
  //   icon: notificationIcon,
  //   class: 'font-weight-bold',
  // },
  {
    title: 'Account',
    icon: settingsIcon,
    link: { name: 'account' },
  },
];

const GUEST_ROUTES = [
  // Module: Post Feed
  // Uncomment the links here for Post Feed
  // {
  //   title: 'Browse Jobs',
  //   link: { name: 'job-feed' },
  //   icon: jobsIcon,
  //   class: 'font-weight-bold',
  // },
  // Module: Marketplace
  // Uncomment the links here for Marketplace
  // {
  //   title: 'Market Place',
  //   link: { name: 'marketplace' },
  //   icon: marketplaceIcon,
  //   class: 'font-weight-bold',
  // },
  {
    title: 'Login',
    icon: logoutIcon,
    link: { name: 'login' },
  },
];

export { AUTH_ROUTES, GUEST_ROUTES };
